import { UserValidationSchema } from '@lifk/types';
import { z } from 'zod';
import { UUIDValidationSchema } from './uuid';
// Schema for user registration
const UserRegistrationValidationSchema = UserValidationSchema.extend({
    organization: z.string(),
    marketingAccepted: z.boolean(),
    privacyAccepted: z.boolean().refine((val) => val === true, {
        message: 'Privacy policy must be accepted'
    }),
    workshopToken: z.string().optional()
}).omit({ avatarColor: true });
// Schema for admin user management
const UserAdminRegistrationValidationSchema = UserValidationSchema.extend({
    role: z.string()
});
const UserRegistrationUpdateValidationSchema = z.object({
    _id: UUIDValidationSchema,
    marketingAccepted: z.boolean(),
    privacyAccepted: z.boolean().refine((val) => val === true, {
        message: 'Privacy policy must be accepted'
    })
});
// Schema for user update validation
const UserUpdateValidationSchema = UserAdminRegistrationValidationSchema.extend({
    _id: UUIDValidationSchema,
    marketingAccepted: z.string().optional().nullable(),
    toolAnalytics: z.boolean(),
    hasSeenOnboardingModal: z.boolean().optional(),
    hasSeenTutorialPrompt: z.boolean().optional()
}).omit({ password: true });
// Schema for user reset password validation
const UserResetPasswordValidationSchema = z.object({
    password: z.string(),
    resetPasswordToken: z.string()
});
// Schema for user update password validation
const UserUpdatePasswordValidationSchema = z.object({
    _id: UUIDValidationSchema,
    currentPassword: z.string(),
    newPassword: z.string()
});
// Schema for user forgot password validation
const UserForgotPasswordValidationSchema = z.object({
    email: z.string().email()
});
// Schema for guest registration
const GuestValidationSchema = z.object({
    firstName: z.string().optional(),
    lastName: z.string().optional()
});
export { GuestValidationSchema, UserAdminRegistrationValidationSchema, UserForgotPasswordValidationSchema, UserRegistrationUpdateValidationSchema, UserRegistrationValidationSchema, UserResetPasswordValidationSchema, UserUpdatePasswordValidationSchema, UserUpdateValidationSchema, UserValidationSchema };
//# sourceMappingURL=user.js.map